export default __webpack_public_path__ + "static/media/hht1_ep04_timeline_q03_a.dd9ca2aa.png";